import { FC } from "react";
import { EDetailSection } from "@/models/common/enums";
import useSticky from "@/hooks/useSticky";
import styles from "../../styles/detail/DetailRecap.module.scss";
import PackageDetailNavbar from "./PackageDetailNavbar";

const PackageDetailRecap: FC<{
    showAccomodations?: boolean;
    isRequestAQuote: boolean;
    handleNavigation: (el: EDetailSection) => void;
}> = ({ showAccomodations = true, handleNavigation, isRequestAQuote }) => {
    const { sticky, stickyRef } = useSticky();

    return (
        <>
            <div className={styles.customContainer} />
            <div
                ref={stickyRef}
                className={`w-100 ${styles.navContainer} ${
                    sticky && styles.isSticky
                }`}
            >
                <PackageDetailNavbar
                    showAccomodations={showAccomodations}
                    handleNavigation={handleNavigation}
                    isRequestAQuote={isRequestAQuote}
                />
            </div>
        </>
    );
};

export default PackageDetailRecap;
